import { AppConfig, Cradle } from '@solo/app-core';
import { useCradle } from '@/app/contexts';

export function useConfig(): AppConfig {
  const { config } = useCradle<Cradle>();

  return config;
}
